import { httpClient } from '@/utils/http'

/**
 * 获取充值套餐
 */
export class StoreAPI {
  static async getRechargePackage(data: any): Promise<any> {
    return httpClient.post<any[]>('/rechargePackage', data)
  }
  /**
   * 获取消费记录
   */
  static async getConsumptionRecord(data: any): Promise<any> {
    return httpClient.post<any[]>('/userBill', data)
  }

  /**
   * H5 支付接口
   */
  static async createPayment(data: {
    productId?: number
    amount?: number
    payType?: string
    [key: string]: any
  }): Promise<any> {
    return httpClient.post<any>('https://api.chat.test.muyuhan.xin/api/v5Pay.html', data)
  }
  /**
   * 多渠道充值套餐
   */
  static async getRechargePackageChannel(data: any): Promise<any> {
    return httpClient.post<any>('/rechargePackageChannel', data)
  }
}

export default {
  StoreAPI
}
